import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Menu from './components/Menu';
import Accordion from './components/Accordion';
import TrainingFilterSlideIn from './components/TrainingFilterSlideIn';
import ResponsiveVideo from './components/ResponsiveVideo';
import VideoPlayer from './components/VideoPlayer';
import TrainingFilter from './components/TrainingFilter';
import Modal from './components/Modal';
import AOS from 'aos';

export class Alfred {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Alfred.domReady()]).then(() => this.init());
	}

	init() {
		document.dispatchEvent(new Event('bless'));

		ResponsiveVideo.init();
		VideoPlayer.init();
		AOS.init();
		new Menu();
		new Accordion();
		new Modal();

		const $filterMenu = document.querySelector('[data-filter-menu]');
		if ($filterMenu) {
			new TrainingFilterSlideIn();
		}

		const $trainingfilter = document.querySelector('[data-trainingfilter] form');
		if ($trainingfilter) {
			new TrainingFilter($trainingfilter);
		}
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();

// jQuery document ready:

// (function($) {
// 	$('body').trigger('bless');
// })(jQuery);
